module.exports = "../dist/img/upper-banner-43.08c4.jpg";